import React from "react";
import { Database, Server, Cpu, Brain, Boxes, HardDrive, Rocket, KeyRound, Activity, Radio } from "lucide-react";

const ICONS = {
  BigQuery: Database,
  "Cloud SQL": Server,
  "Compute Engine": Cpu,
  "Vertex AI": Brain,
  GKE: Boxes,
  "Cloud Storage": HardDrive,
  "Cloud Run": Rocket,
  IAM: KeyRound,
  "Cloud Operations Suite": Activity,
  "Cloud Pub/Sub": Radio,
  // AWS
  "Amazon EC2": Cpu, "Amazon RDS": Server, "Amazon S3": HardDrive, "Amazon EKS": Boxes,
  "Amazon Redshift": Database, "Amazon SageMaker": Brain, "AWS Lambda": Rocket,
  "Amazon DynamoDB": Server, "Amazon CloudFront": Radio, "Amazon CloudWatch": Activity,
  // Azure
  "Virtual Machines": Cpu, "Azure SQL": Server, "Blob Storage": HardDrive, AKS: Boxes,
  "Synapse Analytics": Database, "Azure OpenAI": Brain, "Azure Functions": Rocket,
  "Cosmos DB": Server, "Managed Disks": HardDrive, "Azure Monitor": Activity,
  "Front Door / CDN": Radio, Reservations: Activity,
  // OCI
  "OCI Compute": Cpu, "Autonomous Database": Server, "Object Storage": HardDrive, OKE: Boxes,
  "Block Volume": HardDrive, "Data Science": Brain, "Load Balancer": Radio,
  FastConnect: Radio, "Universal Credits": Activity, "MySQL HeatWave": Server,
};

const COLORS = {
  BigQuery: { fg: "#00579e", bg: "#dbeafe" },
  "Cloud SQL": { fg: "#15803d", bg: "#dcfce7" },
  "Compute Engine": { fg: "#9a3412", bg: "#ffedd5" },
  "Vertex AI": { fg: "#6d28d9", bg: "#ede9fe" },
  GKE: { fg: "#0e7490", bg: "#cffafe" },
  "Cloud Storage": { fg: "#374151", bg: "#f3f4f6" },
  "Cloud Run": { fg: "#be185d", bg: "#fce7f3" },
  IAM: { fg: "#a16207", bg: "#fef3c7" },
  "Cloud Operations Suite": { fg: "#475569", bg: "#e2e8f0" },
  "Cloud Pub/Sub": { fg: "#0d9488", bg: "#ccfbf1" },
  // AWS (amber family)
  "Amazon EC2": { fg: "#b45309", bg: "#fef3c7" },
  "Amazon RDS": { fg: "#92400e", bg: "#fef3c7" },
  "Amazon S3": { fg: "#a16207", bg: "#fefce8" },
  "Amazon EKS": { fg: "#b45309", bg: "#fff7ed" },
  "Amazon Redshift": { fg: "#9a3412", bg: "#ffedd5" },
  "Amazon SageMaker": { fg: "#7c2d12", bg: "#ffedd5" },
  // Azure (blue family)
  "Virtual Machines": { fg: "#0078d4", bg: "#dbeafe" },
  "Azure SQL": { fg: "#075985", bg: "#e0f2fe" },
  "Blob Storage": { fg: "#1d4ed8", bg: "#dbeafe" },
  AKS: { fg: "#0369a1", bg: "#e0f2fe" },
  "Synapse Analytics": { fg: "#1e40af", bg: "#dbeafe" },
  "Azure OpenAI": { fg: "#4338ca", bg: "#e0e7ff" },
  "Cosmos DB": { fg: "#0e7490", bg: "#cffafe" },
  "Managed Disks": { fg: "#334155", bg: "#e2e8f0" },
  "Azure Monitor": { fg: "#475569", bg: "#e2e8f0" },
  // OCI (red family)
  "OCI Compute": { fg: "#c74634", bg: "#fee2e2" },
  "Autonomous Database": { fg: "#b91c1c", bg: "#fee2e2" },
  "Object Storage": { fg: "#9f1239", bg: "#ffe4e6" },
  OKE: { fg: "#be123c", bg: "#ffe4e6" },
  "Block Volume": { fg: "#7f1d1d", bg: "#fee2e2" },
  "Data Science": { fg: "#9d174d", bg: "#fce7f3" },
  "Universal Credits": { fg: "#7c2d12", bg: "#ffedd5" },
};

export default function ServicePill({ service }) {
  const Icon = ICONS[service] || Database;
  const c = COLORS[service] || { fg: "#1f2937", bg: "#f3f4f6" };
  return (
    <span
      data-testid={`service-${service?.replace(/\s+/g, "-").toLowerCase()}`}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium"
      style={{ color: c.fg, background: c.bg }}
    >
      <Icon className="w-3 h-3" strokeWidth={2.2} />
      {service}
    </span>
  );
}
